document.addEventListener('DOMContentLoaded', function () {
    const cartButton = document.querySelector('.cart-button');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartItemsContainer = document.querySelector('.cart-items');
    const cartTotalPrice = document.querySelector('.cart-button-container .cart-total-price');

    cartButton.addEventListener('click', function () {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                populateCartDrawer(data);
                cartDrawer.classList.toggle('open');
                updateCartBubble()
            });
    });

    document.addEventListener('click', function (event) {
        if (!cartDrawer.contains(event.target) && !cartButton.contains(event.target)) {
            cartDrawer.classList.remove('open');
        }
    });

    function populateCartDrawer(cart) {
        cartItemsContainer.innerHTML = '';
        cart.items.forEach(item => {
            const cartItem = document.createElement('div');
            cartItem.classList.add('cart-item');
            cartItem.setAttribute('data-key', item.key);

            let sortedOptions = item.options_with_values.sort((a, b) => {
                if (a.name.toLowerCase() === 'color') return -1;
                if (b.name.toLowerCase() === 'color') return 1;
                return 0;
            }).filter(option => option.name.toLowerCase() !== 'title' && option.value.toLowerCase() !== 'default title');

            for (let key in item.properties) {
                if (key != 'partsPageURL') {
                    sortedOptions.push({
                        name: key,
                        value: item.properties[key]
                    });
                }
            }

            const optionValues = sortedOptions.map(option => {
                let value = option.value;
                if (option.name.toLowerCase() === 'size') {
                    value += ' Diameter';
                }
                return value;
            }).join(', ');
            let titleLink;
            if (!!item.properties.partsPageURL) {
                titleLink = `<a class="cart-item-title" href="${item.properties.partsPageURL}">${item.title}</a>`;
            } else {
                titleLink = `<a class="cart-item-title" href="${item.url}">${item.title}</a>`;
            }
            cartItem.innerHTML = `
                <div class="image_container">
                    <img src="${item.image}" alt="${item.title}" class="cart-item-image" />
                </div>
                <div class="cart-item-details">
                    <div class="cart-item-title-quantity">
                        ${titleLink}
                        <div class="quantity-controls">
                            <button class="quantity-minus" data-key="${item.key}">−</button>
                            <input type="text" value="${item.quantity}" readonly />
                            <button class="quantity-plus" data-key="${item.key}">+</button>
                        </div>
                    </div>
                    <div class="variant-options">
                        <p>${optionValues}</p>
                    </div>
                    <p class="cart-item-price">$${(item.price / 100).toFixed(2)}</p>
                    <button class="remove-item" data-key="${item.key}">Remove</button>
                </div>
            `;
            cartItemsContainer.appendChild(cartItem);
            updateCartBubble();
        });
        cartTotalPrice.textContent = `$${(cart.total_price / 100).toFixed(2)}`;

        document.querySelectorAll('.quantity-minus').forEach(button => {
            button.addEventListener('click', function () {
                updateCartQuantity(button.dataset.key, -1);
            });
        });

        document.querySelectorAll('.quantity-plus').forEach(button => {
            button.addEventListener('click', function () {
                updateCartQuantity(button.dataset.key, 1);
            });
        });

        document.querySelectorAll('.remove-item').forEach(button => {
            button.addEventListener('click', function () {
                removeCartItem(button.dataset.key);
                updateCartBubble();
            });
        });

        const variantOptions = document.querySelectorAll('.variant-options')
        variantOptions.forEach(
            (option) => {
                const text = option.querySelector('p').textContent;
            if(text == 'Default Title') {
                option.style.display = 'none';
             }
        });
    }


    function removeCartItem(key) {
        console.log("removing " + key)
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: key,
                quantity: 0
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log('Item removed from cart:', data);
                var cartItemElement = document.querySelector(`.cart-item[data-key="${key}"]`);
                if (cartItemElement) {
                    cartItemElement.remove();
                    updateCartBubble();
                }
            })
            .catch(error => {
                console.error('Error removing item from cart:', error);
            });
    }

    function updateCartQuantity(key, change) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                const item = data.items.find(item => item.key === key);
                if (item) {
                    const newQuantity = item.quantity + change;
                    if (newQuantity > 0) {
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: key,
                                quantity: newQuantity
                            })
                        })
                            .then(response => response.json())
                            .then(data => {
                                populateCartDrawer(data);
                                updateCartBubble()
                            });
                    }
                }
            });
    }
});

function updateCartBubble() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var cartBubble = document.querySelector('.cart-bubble');
            if (data.item_count > 0) {
                if (!cartBubble) {
                    cartBubble = document.createElement('div');
                    cartBubble.classList.add('cart-bubble');
                    document.querySelector('.cart-button').appendChild(cartBubble);
                }
                cartBubble.textContent = data.item_count;
            } else if (cartBubble) {
                cartBubble.remove();
            }
        });
}

document.querySelectorAll('.cart-drawer .remove-item').forEach((removeButton) => {
    removeButton.addEventListener('click', function () {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: removeButton.dataset.id,
                quantity: 0
            })
        })
            .then(() => {
                updateCartBubble();
            });
    });
});

document.querySelectorAll('.quantity-minus').forEach(button => {
    button.addEventListener('click', function () {
        updateCartQuantity(button.dataset.key, -1).then(() => {
            updateCartBubble();
        });
    });
});
document.querySelectorAll('.quantity-plus').forEach(button => {
    button.addEventListener('click', function () {
        updateCartQuantity(button.dataset.key, 1).then(() => {
            updateCartBubble();
        });
    });
});

setTimeout(() => {
    const productTitle = document.querySelectorAll('.item-title')
    if(productTitle.length) {
        productTitle.forEach((title) => {
        if(title.textContent == 'Wall Mounting Kit' || title.textContent == 'Misting Kit') {
            title.nextElementSibling.textContent = '';
        }
        })
    }
}, 1000);


updateCartBubble();
